export default value =>
  typeof value === 'object' &&
  value !== null &&
  (value.length === undefined || value.length === null);
